<template>
  <div>
    <div class="c-sidenav-profile">
      <div class="c-sidenav-profile__nav-wrapper" @click="isProfileOpen = !isProfileOpen" @keyup.enter="isProfileOpen = !isProfileOpen" tabindex="0">
        <div class="h-8 w-8">
          <base-avatar :content="userInitials" />
        </div>
        <div class="c-sidenav-profile__nav-text">
          {{ $t('label.myProfile') }}
        </div>
        <font-awesome-icon :class="['c-sidenav-profile__nav-arrow', {'c-sidenav-profile__nav-arrow--rotated': isProfileOpen || isAnyLinkActive}]" :icon="['fal', 'chevron-down']"/>
      </div>

      <transition-collapse-height>
        <ul class="c-sidenav-menu__sub" v-if="isProfileOpen || isAnyLinkActive">
          <li class="c-sidenav-menu__item" :key="link.title" v-for="link in profileLinks">
            <router-link :class="['c-sidenav-menu__wrapper-sub', {'c-sidenav-menu__wrapper-sub--is-active': isLinkActive(link) }]" :to="link.route" :title="link.title" @click.native="closeMenu">
              <div class="c-sidenav-menu__text">
                <div class="c-sidenav-menu__text-title">
                  {{ link.title }}
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </transition-collapse-height>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { menu } from '@/mixins/helpers'

import TransitionCollapseHeight from '@/components/Transitions/TransitionCollapseHeight'

export default {
  name: 'SideNavProfile',

  mixins: [ menu ],

  components: { TransitionCollapseHeight },

  data () {
    return {
      isProfileOpen: false,

      profileLinks: [
        {
          title: this.$i18n.t('label.myProfile'),
          route: { name: 'profile' }
        },
        {
          title: this.$i18n.t('label.myReportQueue'),
          route: { name: 'reportingOverview' }
        },
        {
          title: this.$i18n.t('label.logout'),
          route: { name: 'signOut' }
        }
      ]
    }
  },

  computed: {
    ...mapState({
      userInfo: state => state.authorization.userInfo
    }),

    isAnyLinkActive () {
      return this.profileLinks.some(link => this.isLinkActive(link))
    },

    userInitials () {
      return `${this.userInfo.givenName.charAt(0)}${this.userInfo.familyName.split(' ').pop().charAt(0)}`
    }
  },

  methods: {
    isLinkActive (link) {
      return link.route.name === this.$route.name
    }
  }
}
</script>
